import elt from "../html/elt";
import injectCSS from "../html/inject-css";
import { parseFraction } from "../math/parse-fraction";

/**
 * Displays an HTML input with the units, typically 'in', 'mm', or '°', using
 * Bootstrap 5 class names.
 */
export class CpsInputWithUnits extends HTMLElement {

    input: HTMLInputElement;
    unitsElt: HTMLElement;

    constructor() {
        super();
        this.input = elt("input", { "class" : "form-control" });
        this.unitsElt = elt("span", { "class": "input-group-text" });

        this.input.addEventListener('focus', () => this.input.select());
    }

    connectedCallback() {
        this.classList.add("input-group");
        this.append(this.input);
        this.append(this.unitsElt);
    }

    static observedAttributes = ["value", "units", "hidden"];

    attributeChangedCallback(name: string, _old: string, newValue: string) {
        switch(name) {
            case "value":
                this.value = newValue;
                break;
            case "units":
                this.units = newValue;
                break;
            case "disabled":
                this.hidden = newValue != null;
                break;
        }
    }

    get value(): string {
        return String(parseFraction(this.input.value));
    }

    set value(value: string) {
        this.input.value = value;
    }

    get units(): string {
        return this.unitsElt.innerText;
    }

    set units(value: string) {
        this.unitsElt.innerText = value;
    }

    get hidden(): boolean {
        return this.input.disabled;
    }

    set hidden(value: boolean) {
        if(value) {
            this.setAttribute('hidden', '');
        } else {
            this.removeAttribute('hidden');
        }
        this.input.disabled = value;
    }
}
try {
    customElements.define("cps-input-with-units", CpsInputWithUnits);
} catch(_error) {
    // Drop it, the element was already defined by the floor planner, or vice
    // versa.
}

injectCSS(`
cps-input-with-units[hidden] {
    opacity: 0%;
}
`);
